import React from 'react';

interface ConfirmActiveProps {
  size?: number;
  fillColor?: string;
  strokeColor?: string;
}

const ConfirmActive: React.FC<ConfirmActiveProps> = function (props: ConfirmActiveProps) {
  const {
    size = 40,
    fillColor = '#66D392',
    strokeColor = '#66D392',
  } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
    >
      <rect
        x="0.5"
        y="0.5"
        width="39"
        height="39"
        rx="3.5"
        fill={fillColor}
        stroke={strokeColor}
      />
      <path
        d="M13 21L16.2331 23.4248C16.6618 23.7463 17.2677 23.6728 17.607 23.2581L26 13"
        stroke="white"
        strokeLinecap="round"
      />
    </svg>
  );
};

ConfirmActive.defaultProps = {
  size: 40,
  fillColor: '#66D392',
  strokeColor: '#66D392',
};

export default ConfirmActive;
